import { useContext } from 'react';

import { ERROR_ACTION } from 'constants/error';
import ErrorBoundaryContext from 'context/ErrorBoundaryContext';

import { isProgressUnauthorized } from './progressError';

/** Sends a progress 401 to the ErrorBoundary, as `apiRequest`'s `setError` does elsewhere. */
export const useExpireSessionOnUnauthorized = () => {
  const errorBoundary = useContext(ErrorBoundaryContext);

  return (error: unknown) => {
    if (!isProgressUnauthorized(error)) return;

    errorBoundary?.setError({ errorAction: ERROR_ACTION.SHOW_UNAUTHORIZED_ERROR, hasError: true });
  };
};
